/* Mapping for BE to FE text */
import { SearchToken } from './search-token.interface';
import {
    PreferredPaymentIdentifierType,
    PreferredPaymentMode
} from './payments.interface';

export enum ProxyTypeName {
    phoneNumber = 'phone',
    loyaltyNumber = 'loyaltynumber',
    email = 'email',
    userCode = 'userCode',
    houseHoldId = 'houseHoldId',
    payPalId = 'PayPalID',
    venmoId = 'VenmoID'
}

/**
 * This is needed for duplicate receipt components.
 * RIQ sends proxy_type as 'Phone', 'Email', 'UserCode' (which we receive as part of
 * duplicate_details object in transaction list/transaction details data)
 * CPA expects 'phone_number', 'email', 'user_code' (which we receive as part of
 * search shopper API).
 * To compare the 2 values, we need this mapping.
 * NOTE: Loyalty Card is an optional proxy type [we will have the email/user code/phone number
 * of the shopper even if loyalty card is present]. So, we don't need to map it.
 */
export enum ProxyTypeRiqToCpaMapping {
    Phone = 'phone_number',
    Email = 'email',
    UserCode = 'user_code',
    HouseholdID = 'albertsons_household_id_sha256', // TODO: This is not used currently - added for future use in case it is populated in duplicate details
    PayPalID = 'PayPalID',
    VenmoID = 'VenmoID'
}

export const ProxyType = {
    [ProxyTypeName.phoneNumber]: 'Phone Number',
    [ProxyTypeName.loyaltyNumber]: 'Loyalty Number',
    [ProxyTypeName.email]: 'Email',
    [ProxyTypeName.userCode]: 'User Code',
    [ProxyTypeName.houseHoldId]: 'Household ID',
    [ProxyTypeName.payPalId]: 'PayPal ID',
    [ProxyTypeName.venmoId]: 'Venmo ID'
};

export enum SearchShopperGridColumnType {
    Link,
    Name,
    PartnerName,
    LoyaltyCard,
    Generic
}

export class SearchShopperGridColumnModel {
    type: SearchShopperGridColumnType;
    field: string;
    title: string;
    format: string;
    width: number;
}

export interface SearchFormCriteria {
    partnerName: string;
    proxyType: string;
    proxyValue: string;
}

export interface Proxy {
    proxy_name: string;
    proxy_description: string;
}

export interface SupportedPaymentMode {
    mode: PreferredPaymentMode;
    supported_identifier_types: PreferredPaymentIdentifierType[];
}

export interface PartnerDetail {
    partner_id: string;
    partner_code: string;
    partner_name: string;
    eligible_proxies: Proxy[];
    application_id: string;
    is_rebate?: boolean;
    shopper_support_partner_type?: PartnerType;
    partnerSearchToken?: string;
    supported_payment_modes?: SupportedPaymentMode[];
}

/**
 * Enum representing the types of partners in the system.
 * To be used in place of is_rebate flag down the line.
 */
export enum PartnerType {
    Digital = 'DIGITAL',
    DigitalAndRebate = 'DIGITAL_AND_REBATE',
    DigitalAndSales = 'DIGITAL_AND_SALES',
    DigitalSalesAndRebate = 'DIGITAL_SALES_AND_REBATE',
    RebateAffiliate = 'REBATE_AFFILIATE',
    RebateRetailer = 'REBATE_RETAILER',
    RebateRetailerFreedom = 'REBATE_RETAILER_FREEDOM',
    RIQDigitalSalesAndRebate = 'RIQ_DIGITAL_SALES_AND_REBATE'
}

export const ALL_PARTNERS_SEARCH_TOKEN = 'allPartnersSearchToken';
